import {
  LOAD_COMM_PREFS_KEYS,
  LOAD_CONTACT_PREFS_KEYS,
  LOAD_COMM_OPTION_VALUE,
  LOAD_CONTACT_OPTION_VALUE,
  SAVE_CONTACT_PREF,
  SAVE_COMMUNICATION_PREF,
  SET_IS_ELGIBLE_CUSTOMISED,
  PERSON_NOT_FOUND,
  SET_IS_VALUE_CHANGED,
  SET_IS_COMM_VALUE_CHANGED,
  LOAD_CONTACT_OPTION_VALUE_ONBOARD,
} from "../../actions/policy/policyActions";

const initialState = {
  communicationPreferencekeys: null,
  contactPreferencekeys:null,
  communicationValue:null,
  contactValue:null,
  contactValueOnboard:null,
  saveContactPref:false,
  saveCommunicationPref:false,
  isElgibleCustomised: null,
  personnotfound:false,
  IsValueChanged:false,
  IsCommValueChanged:false,
};

export default function preferenceReducer(state = initialState, action) {

  switch (action.type) {
    case LOAD_COMM_PREFS_KEYS:
      return {
        ...state,
        communicationPreferencekeys:action.payload
      };
    case LOAD_CONTACT_PREFS_KEYS:
      return {
        ...state,
        contactPreferencekeys:action.payload
      };
    case LOAD_COMM_OPTION_VALUE:
      return {
        ...state,
        communicationValue:action.payload
      };
    case LOAD_CONTACT_OPTION_VALUE_ONBOARD: 
      return {
        ...state,
        contactValueOnboard:action.payload
      };     
    case LOAD_CONTACT_OPTION_VALUE:
      return {
        ...state,
        contactValue:action.payload
      };
    case SAVE_CONTACT_PREF:
      return {
        ...state,
        saveContactPref:action.payload
      };
    case SAVE_COMMUNICATION_PREF:
      return {
        ...state,
        saveCommunicationPref:action.payload
      };
    case SET_IS_ELGIBLE_CUSTOMISED:
      return {
        ...state,
        isElgibleCustomised:action.payload
      };
    case PERSON_NOT_FOUND:
      return {
        ...state,
        personnotfound:action.payload
      };
    case SET_IS_VALUE_CHANGED:
      return {
        ...state,
        IsValueChanged:action.payload
      };
    case SET_IS_COMM_VALUE_CHANGED:
      return {
        ...state,
        IsCommValueChanged:action.payload
      };
    default:
      return state;
  }
}
